import { SoftwareCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const SoftwareCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case SoftwareCCActionType.SoftwareCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default SoftwareCCReducer
